import React from 'react';
import { FiGithub, FiLinkedin, FiMail, FiArrowUpRight } from 'react-icons/fi';
import useReveal from '../../hooks/useReveal';
import { portfolioData } from '../../data/portfolioData';

const iconFor = {
  github: FiGithub,
  linkedin: FiLinkedin,
  mail: FiMail,
};

export default function Contact() {
  const { contact } = portfolioData;
  const [ref, shown] = useReveal();

  return (
    <section className="section contact" id="contact" ref={ref}>
      <div className={`reveal ${shown ? 'in' : ''}`}>
        <span className="eyebrow" style={{ justifyContent: 'center' }}>
          04 — Say hello
        </span>
        <h2 className="contact-title">
          Let's <span className="cyan-text">deploy</span>
          <br />
          <span className="outline-text">together</span>
        </h2>
        <a href={`mailto:${contact.email}`} className="contact-email interactive">
          {contact.email} <FiArrowUpRight style={{ verticalAlign: 'middle' }} />
        </a>

        <div className="contact-details">
          <span>{contact.phone}</span>
          <span>{contact.location}</span>
        </div>

        <div className="socials">
          {contact.social.map((s) => {
            const Icon = iconFor[s.icon] || FiArrowUpRight;
            return (
              <a
                key={s.name}
                href={s.url}
                className="social-link interactive"
                target="_blank"
                rel="noreferrer"
                aria-label={s.name}
              >
                <Icon size={20} />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
